import { Component, OnInit } from '@angular/core';
import { ReminderState } from 'app/store/reminder/reminder.state';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { Reminder } from 'app/models/dto/reminder.model';
import { GetRemindersToday } from 'app/store/reminder/reminder.actions';

@Component({
  selector: 'app-reminders-today-smart',
  templateUrl: './reminders-today-smart.component.html',
  styleUrls: ['./reminders-today-smart.component.scss'],
  standalone: false
})
export class RemindersTodaySmartComponent implements OnInit {
  reminders$: Observable<Reminder[]> = this.store.select(ReminderState.remindersToday);

  constructor(
    private store: Store
  ) { }

  ngOnInit() {
    this.store.dispatch(new GetRemindersToday);
  }
}
